// Estimate calculation helpers — pure functions, no React, no side effects.
// Source of truth for all estimate math used in the builder, PDF, and metrics.

export const TAX_RATE = 0.0825
export const LABOR_BURDEN_RATE = 0.25

const LABOR_KEYWORDS = ['labor', 'crew', 'install', 'trim', 'removal', 'pruning', 'grinding', 'haul', 'demo', 'grade', 'prep', 'clear', 'dig', 'excavat', 'placing', 'plant']
const EQUIPMENT_KEYWORDS = ['equipment', 'machine', 'skid', 'rental', 'steer', 'tractor', 'loader']

export function detectType(item, sectionName) {
  const sName = (sectionName || '').toLowerCase()
  const desc = (item.description || '').toLowerCase()
  // type_locked means a human explicitly chose this type (dropdown, or picking a
  // material off the price list) -- that choice is authoritative and wins over every
  // heuristic below it, including the section-name shortcut: a "Labor"-named section
  // still can't override an item the user explicitly locked to Material. Without this
  // check, a Material item whose description contains a word like "install" or "plant"
  // would silently get re-priced as unmarked-up Labor every time this runs, even right
  // after the user corrected it back to Material.
  if (item.type_locked) return item.item_type
  if (sName.includes('overhead')) return 'Overhead'
  if (sName.includes('labor') || sName.includes('crew')) return 'Labor'
  if (sName.includes('equipment')) return 'Equipment'
  if (LABOR_KEYWORDS.some(k => desc.includes(k))) return 'Labor'
  if (EQUIPMENT_KEYWORDS.some(k => desc.includes(k))) return 'Equipment'
  return item.item_type || 'Material'
}

export function getMarkupPct(item) {
  if (item.markup_type === 'custom') return parseFloat(item.custom_markup || 0)
  return parseFloat(item.markup_pct ?? 100)
}

export function itemClientPrice(item, sectionName, overheadPerLaborHour = 0) {
  const cost = parseFloat(item.unit_cost || 0)
  const qty = parseFloat(item.qty || 0)
  const rawCost = cost * qty
  const type = detectType(item, sectionName)
  if (type === 'Overhead') return 0
  if (type === 'Labor') return rawCost + (qty * overheadPerLaborHour)
  return rawCost * (1 + getMarkupPct(item) / 100)
}

export function itemTrueCost(item) {
  return parseFloat(item.unit_cost || 0) * parseFloat(item.qty || 0)
}

export function sectionClientTotal(section, overheadPerLaborHour = 0) {
  if (section.is_overhead) return 0
  return section.items.reduce((s, i) => s + itemClientPrice(i, section.name, overheadPerLaborHour), 0)
}

export function sectionTrueCost(section) {
  return section.items.reduce((s, i) => s + itemTrueCost(i), 0)
}
